import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
  connect() {
    const env = document.documentElement.dataset.env
    // Skip auto-dismiss only in test environment
    if (env === 'test') return

    this.element.style.animation = "fade-in-and-out 5s"
    this.timeout = setTimeout(() => { this.element.remove() }, 5000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
